import React, { useState } from "react";
import { api } from "../api";
import { useAuth } from "../auth-context";

// Site-wide floating button - visible on every page, logged in or not - so
// a student who hits a broken video, a layout glitch, anything, can flag it
// without hunting for a support email. Logs to the `issue_reports` table;
// see AdminIssuesPage.jsx for where an admin reviews these.
export default function ReportIssueButton() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const close = () => {
    setOpen(false);
    setTimeout(() => {
      setDone(false);
      setError("");
      setDescription("");
      setEmail("");
    }, 200);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!description.trim()) return;
    setBusy(true);
    setError("");
    try {
      await api.post("/api/issues", {
        description,
        email: user ? undefined : email,
        pageUrl: window.location.href,
      });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" className="report-issue-btn" onClick={() => setOpen(true)}>
        Report an issue
      </button>
      {open && (
        <div className="modal-overlay" onClick={close}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="modal-close" onClick={close} aria-label="Close">
              ×
            </button>
            <h2>Report an issue</h2>
            {done ? (
              <>
                <div className="alert alert-success">Thanks — we've logged this and will look into it.</div>
                <button type="button" className="btn btn-secondary" onClick={close}>
                  Close
                </button>
              </>
            ) : (
              <form onSubmit={submit}>
                {error && <div className="alert alert-error">{error}</div>}
                <label>
                  What went wrong?
                  <textarea
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />
                </label>
                {!user && (
                  <label>
                    Your email (optional)
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                  </label>
                )}
                <button className="btn btn-primary btn-block" disabled={busy}>
                  {busy ? "Sending…" : "Submit"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
